var React = require('react')
var createReactTimeout = require('./reactTimeout.js')

module.exports = createReactTimeout(React)



//////////////////
// WEBPACK FOOTER
// ./~/react-timeout/src/web.js
// module id = ./node_modules/react-timeout/src/web.js
// module chunks = 35783957827783 114276838955818 247658369337294